import React, { FC } from 'react'
import { Field } from 'formik'
import { TextValuePair } from '@mortgage-pos/types'
import { stateTextValuePairs } from '@mortgage-pos/data'
import { useStoreState } from '@mortgage-pos/ui/store'

import Select from '@mortgage-pos/ui/components/Select'
import InfoBlock from '@mortgage-pos/ui/components/InfoBlock'
import { mapStatesDropdownData } from '@mortgage-pos/ui/utils/mapStatesDropdownData'

import { getQuestionDisplayName } from './helpers'
import { RepeatableAddressFields } from './addressAutoComplete'

interface Props {
  addressFields: RepeatableAddressFields[]
}

export const RepeatableManualFields: FC<Props> = ({ addressFields }) => {
  const { licensedStatesCodes } = useStoreState((state) => state.licensedStates)

  const stateOptions: TextValuePair[] = licensedStatesCodes
    ? mapStatesDropdownData(licensedStatesCodes)
    : stateTextValuePairs

  if (!addressFields || !addressFields.length) return null
  return (
    <React.Fragment>
      {addressFields.map(({ defaultField, uniqueField }) => {
        return (
          <Field name={uniqueField} key={uniqueField}>
            {({
              field: { onChange: formikChange },
              meta: { value, error, touched },
              form: { setFieldValue },
            }) => {
              const errorClass = error && touched ? '--error' : ''

              if (defaultField === 'state') {
                return (
                  <Select
                    name={''}
                    title={''}
                    subTitle={'State'}
                    modifierClass={''}
                    infoContent={''}
                    options={stateOptions}
                    value={value}
                    setValue={(value) => {
                      setFieldValue(uniqueField, value)
                    }}
                    touched={touched}
                    error={error}
                  />
                )
              }
              return (
                <div className={`input ${errorClass} `} key={uniqueField}>
                  <label className="input__subtitle" htmlFor={uniqueField}>
                    {getQuestionDisplayName(defaultField)}
                  </label>
                  <input
                    name={uniqueField}
                    className="input__field"
                    data-testid={uniqueField}
                    onChange={(event) => {
                      formikChange(event)
                    }}
                    value={value}
                  />
                  {error && touched ? (
                    <InfoBlock type="danger">{error}</InfoBlock>
                  ) : null}
                </div>
              )
            }}
          </Field>
        )
      })}
    </React.Fragment>
  )
}
